import Vue from 'vue'
import AppShell from './app-shell/AppShell.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

import './styles/style.scss'

Vue.config.productionTip = false

// Ignore Airship components
Vue.config.ignoredElements = [/as-\w+/]

// taken from github.com/CartoDB/AENA/www/sdk
Vue.config.errorHandler = (err, vm, info) => {
  /** Error Handler
    * err: error trace
    * vm: component in which error occured
    * info: Vue specific error information such as lifecycle hooks, events etc.
  **/

  /* eslint-disable */
  console.error('Error catched: \n', err)
  console.info('Source:', vm && vm.$options.name, vm)
  console.info('More info:', info)
  /* eslint-enable */
}

const requireComponent = require.context(
  './components/common',
  true,
  /[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName)
  const componentName = fileName.split('/').pop().replace(/\.\w+$/, '')
  // Register component globally
  Vue.component(
    componentName,
    componentConfig.default || componentConfig
  )
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(AppShell)
}).$mount('#app')
